export const snakize = (obj: Object) => convert(obj, camelToSnakeCase)

export const camelize = (obj: Object) => convert(obj, snakeToCamelCase)

const convert = (obj: Object, converter: (str: string) => string) => {
  if (Array.isArray(obj)) {
    const convertedValue = obj.map((v) =>
      typeof v === 'object' && v !== null ? convert(v, converter) : v,
    )
    return convertedValue
  }

  const result = {} as Object
  Object.keys(obj).forEach((key) => {
    const value = obj[key]
    let convertedValue
    if (Array.isArray(value)) {
      convertedValue = value.map((v) =>
        typeof v === 'object' && v !== null ? convert(v, converter) : v,
      )
    } else if (typeof File !== 'undefined' && value instanceof File) {
      // File オブジェクトはそれ以上再帰的に変換することはしない
      convertedValue = value
    } else if (typeof value === 'object' && value !== null) {
      convertedValue = convert(value, converter)
    } else {
      convertedValue = value
    }
    result[converter(key)] = convertedValue
  })
  return result
}

export const camelToSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)

const snakeToCamelCase = (str: string) =>
  str.replace(/_[a-z]/g, (letter) => `${letter.substring(1).toUpperCase()}`)
